// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"63b95e24","965":"b39e1bfe"}[chunkId] + ".chunk.js";
};